import idx from 'idx';
import { ProprieteModele } from './proprieteModel';

export class ProprieteHelper {
  static readonly MAX_TOTAL_PRICE_EXCLUSIVE = 1000000;

  propriete: ProprieteModele;

  constructor(p: ProprieteModele) {
    this.propriete = p;
  }

  get prixTotal(): number {
    const prixTotal = idx(this.propriete, _ => _.analyseEcartPrequalification.prixTotal);
    return prixTotal ? Number(prixTotal) : Number(this.propriete.prix);
  }

  get indicateur(): string {
    const indicateur = idx(this.propriete, _ => _.analyseEcartPrequalification.indicateurRisque);

    return indicateur ? indicateur.toLocaleLowerCase().replace(/_/g, '-') : null;
  }

  get miseDeFondTropBasse(): boolean {
    return idx(this.propriete, _ => _.analyseEcartPrequalification.indicateurRisque) === 'MISE_FOND_TROP_BASSE';
  }

  /**
   * Mise de fond minimale.
   * Ils se calculent sur la base du prix total de la propriété.
   * @returns prixTotal * 20%
   */
  get miseDeFondMinimale(): number {
    return this.prixTotal * 0.2;
  }

  /**
   * les frais d'acquisitions représentent les frais de démarrage.
   * Ils se calculent sur la base du prix total de la propriété.
   * @returns prixTotal * 3%
   */
  get fraisAcquisition() {
    return Math.round((Number(this.prixTotal) * 3) / 100);
  }

  get texteIndicateur(): string {
    if (this.miseDeFondTropBasse) {
      return 'propriete.type-achat-mise-fond-trop-basse';
    }

    const mapping = {
      haut: 'propriete.type-achat-haut',
      moyen: 'propriete.type-achat-moyen',
      bas: 'propriete.type-achat-bas'
    };

    return this.indicateur && mapping[this.indicateur] ? mapping[this.indicateur] : null;
  }

  get montantTaxesScolaires(): number {
    return this.propriete.montantTaxesScolaires ? this.propriete.montantTaxesScolaires : 0;
  }

  get montantTaxesMunicipales(): number {
    return this.propriete.montantTaxesMunicipales ? this.propriete.montantTaxesMunicipales : 0;
  }

  get montantCoutEnergie(): number {
    return this.propriete.montantCoutEnergie ? this.propriete.montantCoutEnergie : 0;
  }

  get montantFraisCopropriete(): number {
    return this.propriete.montantFraisCopropriete ? this.propriete.montantFraisCopropriete : 0;
  }

  get montantFraisMensuels(): number {
    return Math.round(
      this.montantTaxesScolaires / 12 +
        this.montantTaxesMunicipales / 12 +
        this.montantCoutEnergie +
        this.montantFraisCopropriete
    );
  }

  get isTypeCondo(): boolean {
    return this.propriete.type === '01';
  }

  get requiredFrais(): Array<string> {
    const requiredProps = ['montantTaxesScolaires', 'montantTaxesMunicipales', 'montantCoutEnergie'];

    if (this.isTypeCondo) {
      requiredProps.push('montantFraisCopropriete');
    }

    return requiredProps;
  }

  get isFraisIncomplete(): boolean {
    for (const prop of this.requiredFrais) {
      if (!this.propriete[prop]) {
        return true;
      }
    }

    return false;
  }

  get incompleteFields(): Array<string> {
    const list = [];

    for (const prop of this.requiredFrais) {
      if (!this.propriete[prop]) {
        list.push(prop);
      }
    }

    return list;
  }

  get adresse(): string {
    return this.propriete.proprieteAdresse ? this.propriete.proprieteAdresse.adresseFormattee : '';
  }

  get hasRenovations() {
    return this.propriete.montantFraisRenovations > 0;
  }

  get hasPrimeAssureur() {
    return this.propriete.analyseEcartPrequalification.montantPrimeAssureurHypothecaire > 0;
  }

  get isOldPropriete(): boolean {
    return (
      this.propriete.type !== null ||
      this.propriete.titre !== null ||
      (this.propriete.proprieteAdresse && this.propriete.proprieteAdresse.adresseFormattee != null) ||
      this.propriete.notePersonnelle !== null
    );
  }
}
